import React, { FC, useEffect, useState } from "react";
import { toast } from "react-toastify";

import { SettingsIconButton } from "../../../../components/button/SettingsIconButton";
import { SettingsDropdown } from "../../../../components/dropdown/SettingsDropdown";
import { DotsSvg } from "../../../../components/svg/DotsSvg";
import { EditPencilSvg } from "../../../../components/svg/EditPencilSvg";
import { TrashSvg } from "../../../../components/svg/TrashSvg";
import {
  IPaymentMethod,
  useDeletePaymentMethodMutation,
} from "../../../../services/BillingService";
import { serverMessage } from "../../../../utils/serverMessage";
import { PaymentMethodForm } from "./PaymentMethodForm";

type Props = {
  paymentMethod: IPaymentMethod;
  getPaymentMethods: () => Promise<void>;
};

export const PaymentMethod: FC<Props> = ({
  paymentMethod,
  getPaymentMethods,
}) => {
  const [isOpenEdit, setIsOpenEdit] = useState(false);

  const [
    deletePaymentMethod,
    {
      isLoading: isLoadingDelete,
      isSuccess: isSuccessDelete,
      isError: isErrorDelete,
      error: deleteError,
    },
  ] = useDeletePaymentMethodMutation();

  useEffect(() => {
    if (isSuccessDelete) {
      toast("Payment method successfully Deleted", {
        type: "success",
      });
      void getPaymentMethods();
    }
  }, [isSuccessDelete]);

  useEffect(() => {
    if (isErrorDelete) {
      // BSET-004 (QA batch 17): "Used by N payments…" from the server.
      toast(serverMessage(deleteError, "Something went wrong"), {
        type: "error",
      });
    }
  }, [deleteError, isErrorDelete]);

  return (
    <React.Fragment>
      {isOpenEdit ? (
        <PaymentMethodForm
          onClose={() => setIsOpenEdit(false)}
          paymentMethod={paymentMethod}
          onSuccess={getPaymentMethods}
        />
      ) : (
        <div
          className={
            "group grid h-12 grid-cols-[1fr_max-content] items-center border-b border-[#E4E9F2] pl-4 pr-1 last:border-none"
          }>
          <div
            title={paymentMethod.paymentMethod}
            className={"truncate text-base font-medium text-[#3F5266]"}>
            {paymentMethod.paymentMethod}
          </div>
          <div
            className={
              "pointer-events-none opacity-0 transition-opacity duration-100 group-hover:pointer-events-auto group-hover:opacity-100"
            }>
            <SettingsDropdown
              actionsList={[
                {
                  icon: <EditPencilSvg />,
                  name: "Edit",
                  action: () => setIsOpenEdit(true),
                  disabled: isLoadingDelete,
                },
                {
                  icon: <TrashSvg />,
                  name: "Delete",
                  iconColor: "text-[#DC2626]",
                  extraClasses: "text-[#DC2626]",
                  action: () => deletePaymentMethod(paymentMethod?.id || ""),
                  disabled: isLoadingDelete,
                },
              ]}>
              <SettingsIconButton
                icon={<DotsSvg />}
                onClick={() => null}
                extraClasses={"!h-8 !w-8"}
              />
            </SettingsDropdown>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
